module.exports = __webpack_public_path__ + "img/36_9.a77a7a06.png";